import { Link } from "react-router-dom";
import { useTranslations } from "@/lib/useTranslations";

import {
  getSectionSubNavHref,
  isSectionSubNavActive,
  sectionSubNavItems,
} from "@/components/ui/admin/section-sub-nav-items";

interface SectionSubNavProps {
  basePath: string;
  pathname: string;
  orientation?: "horizontal" | "vertical";
}

export function SectionSubNav({
  basePath,
  pathname,
  orientation = "vertical",
}: SectionSubNavProps) {
  const t = useTranslations("sectionNav");
  const tCommon = useTranslations("common");
  const isVertical = orientation === "vertical";

  return (
    <nav
      aria-label={tCommon("sectionNav")}
      className={
        isVertical
          ? "flex w-56 shrink-0 flex-col border-r border-black/10 bg-whart-bg"
          : "border-b border-black/10 bg-whart-bg"
      }
    >
      <ul
        className={
          isVertical
            ? "space-y-1 px-3 py-4"
            : "flex items-center gap-1 overflow-x-auto px-4 py-2"
        }
      >
        {sectionSubNavItems.map((item) => {
          const href = getSectionSubNavHref(basePath, item.slug);
          const isActive = isSectionSubNavActive(pathname, basePath, item.slug);

          return (
            <li key={item.slug} className={isVertical ? undefined : "shrink-0"}>
              <Link
                to={href}
                className={`block text-sm transition-colors ${
                  isVertical
                    ? "border-l-2 px-3 py-2"
                    : "border-b-2 px-3 py-2"
                } ${
                  isActive
                    ? isVertical
                      ? "border-whart-dark bg-neutral-100 font-medium text-whart-text"
                      : "border-whart-dark font-medium text-whart-text"
                    : isVertical
                      ? "border-transparent text-neutral-600 hover:bg-neutral-50 hover:text-whart-text"
                      : "border-transparent text-neutral-600 hover:border-black/10 hover:text-whart-text"
                }`}
              >
                {t(item.labelKey)}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
